import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Wrench, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useAuth } from '@/contexts/AuthContext';
import { toast } from 'sonner';

function OficinaLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const result = await login(username, password);
      if (result.success) {
        toast.success('Login realizado com sucesso!');
        navigate('/oficina/dashboard');
      } else {
        toast.error(result.error || 'Credenciais inválidas');
      }
    } catch (error) {
      toast.error('Credenciais inválidas');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-obsidian flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-carbon border border-white/10 rounded-xl p-8 shadow-2xl">
          {/* Header */}
          <div className="text-center mb-8">
            <div className="w-20 h-20 bg-gradient-to-br from-blue-500 to-blue-700 rounded-2xl mx-auto flex items-center justify-center mb-4 shadow-lg">
              <Wrench className="w-10 h-10 text-white" />
            </div>
            <h1 className="text-3xl font-bold text-white mb-2">Oficina Mecânica</h1>
            <p className="text-slate-400">Sistema de Gestão</p>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label className="text-slate-400 text-sm">Usuário</Label>
              <Input
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="bg-obsidian border-white/10 text-white"
                placeholder="Digite seu usuário"
                required
              />
            </div>
            <div>
              <Label className="text-slate-400 text-sm">Senha</Label>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="bg-obsidian border-white/10 text-white"
                placeholder="Digite sua senha"
                required
              />
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-electric-blue hover:bg-blue-600 text-white font-medium py-6"
            >
              {loading ? (
                <Loader2 className="w-5 h-5 animate-spin" />
              ) : (
                'ENTRAR'
              )}
            </Button>
          </form>
        </div>

        <p className="text-center text-slate-600 text-xs mt-6">
          Sistema de Gestão de Oficina Mecânica
        </p>
      </div>
    </div>
  );
}

export default OficinaLogin;
